var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "law-query-wrapper"
  }, [_c("div", {
    staticClass: "law-query-title",
    on: {
      click: _vm.toggleShow
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("searching", {
    staticClass: "m-r-4",
    attrs: {
      type: 1,
      "icon-name": "satellite-h5",
      animation: _vm.searching
    }
  }), _c("span", [_vm._v("参考" + _vm._s(_vm.resultList.length) + "条政策法规")])], 1), _c("van-icon", {
    staticClass: "arrow-icon m-l-4",
    class: {
      rotated: _vm.show
    },
    attrs: {
      name: "arrow-down"
    }
  })], 1)]), _c("transition", {
    attrs: {
      name: "fade-right",
      mode: "out-in"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    ref: "newsCardWrapperRef",
    staticClass: "news-card-wrapper m-t-8"
  }, _vm._l(_vm.resultList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "news-card",
      on: {
        click: function click($event) {
          return _vm.viewLawDetail(item);
        }
      }
    }, [_c("div", {
      staticClass: "news-summary"
    }, [_vm._v(" " + _vm._s(index + 1) + "." + _vm._s(item.title))]), _c("div", {
      staticStyle: {
        display: "flex",
        "align-items": "center"
      }
    }, [_c("div", {
      staticClass: "m-r-4",
      staticStyle: {
        width: "14px",
        height: "14px",
        display: "flex",
        "align-items": "center"
      }
    }, [_c("svg-icon", {
      attrs: {
        name: "fav"
      }
    })], 1), _c("div", {
      staticClass: "news-site"
    }, [_vm._v(_vm._s(item.docNum))])])]);
  }), 0)]), _c("van-popup", {
    style: {
      background: _vm.bgColor,
      width: "calc(100vw - 32px)",
      height: "95%",
      "z-index": "4000"
    },
    attrs: {
      round: "",
      closeable: ""
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "law-title"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.lawIdList.length > 1,
      expression: "lawIdList.length > 1"
    }],
    on: {
      click: _vm.previous
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "pre"
    }
  }), _vm._v(" 返回")], 1)]), _c("div", {
    staticClass: "law-content"
  }, [_c("div", [_vm._v(_vm._s(_vm.lawInfo["title"]))]), _c("div", {
    staticClass: "law-attr"
  }, [_c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发文机关：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["pubOffice"]))])]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发文字号：")]), _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.lawInfo["docNum"])
    }
  })]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("发布日期：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["releaseDate"]))])]), _c("div", {
    staticClass: "law-attr-item"
  }, [_c("div", {
    staticClass: "law-attr-label"
  }, [_vm._v("法规时效：")]), _c("div", [_vm._v(_vm._s(_vm.lawInfo["status"]))])])]), _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.lawInfo.content)
    }
  })])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };